var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 2.16699C5.4063 2.16699 1.66797 5.90533 1.66797 10.5003C1.66797 15.0953 5.4063 18.8337 10.0013 18.8337C14.5963 18.8337 18.3346 15.0953 18.3346 10.5003C18.3346 5.90533 14.5963 2.16699 10.0013 2.16699ZM12.7455 14.4228L9.16797 10.8453V5.50033H10.8346V10.1553L13.9238 13.2445L12.7455 14.4228Z",
    fill: "#183059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiry);
export default __webpack_public_path__ + "static/media/Expiry.04b43c2c1a9608ba249e8a506051418e.svg";
export { ForwardRef as ReactComponent };